import script from "./StudentRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentRecord.vue?vue&type=script&setup=true&lang=js"

import "./StudentRecord.vue?vue&type=style&index=0&id=42594b0e&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/mgtpr6vc/mgt-elearning/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42594b0e"]])

export default __exports__